import { ClientConfig } from 'features/dashboard/types'
import { ARVADA_JURISDICTION_ID, OSU_JURISDICTION_ID, ST_AUGUSTINE_JURISDICTION_ID } from 'constants/jurisdictions'


const jurisdictionConfigMap = {
    // Arvada
    [ARVADA_JURISDICTION_ID]: () => import('config/configs/arvada'),
    // OSU
    [OSU_JURISDICTION_ID]: () => import('config/configs/osu'),
    // St Augustine
    [ST_AUGUSTINE_JURISDICTION_ID]: () => import('config/configs/stAugustine')
}


export async function loadConfig(
    jurisdictionId: string
): Promise<ClientConfig | null> {
    const loaderForJurisdiction = jurisdictionConfigMap[jurisdictionId]
    return await loaderForJurisdiction?.().then(_module => _module.default)
}
